var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-select-default-wrapper"},[_vm._t("default"),_c('div',{staticClass:"user-select-default-wrapper__tail",style:(("left: " + (_vm.tailPosition.x) + "px; top: " + (_vm.tailPosition.y) + "px"))})],2)}
var staticRenderFns = []

export { render, staticRenderFns }